// extracted by mini-css-extract-plugin
module.exports = {"pricingText":"pricingText_pricingText__NopcX","container":"pricingText_container__5Ysbx","heading":"pricingText_heading__9jGTn","subParagraph":"pricingText_subParagraph__MQNxF"};